import { render, staticRenderFns } from "./FormLists.vue?vue&type=template&id=099f5fb5&"
import script from "./FormLists.vue?vue&type=script&lang=js&"
export * from "./FormLists.vue?vue&type=script&lang=js&"
import style0 from "./FormLists.vue?vue&type=style&index=0&id=099f5fb5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports